import React, {useState, useEffect} from 'react';
import logo from './logo.svg';
import './App.css';
import ViolenceData from './data';

function App() {

  const [selectedState, setSelectedState] = useState("");

  var states = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ];

  useEffect(() => {

    for(var i = 0; i < states.length; i++){
      var newOption = document.createElement("option");
      newOption.value = states[i];
      newOption.innerText = states[i];
      var stateSelect = document.getElementById("state-select");
      stateSelect.appendChild(newOption);
    }
  }, []);

  function stateChange(e){
    setSelectedState(e.target.value);
  }
  
  return (
    <div className="App">
      <header>
        <h1 className="header-title">Protest Tracker</h1>
      </header>
      <h1 className="page-title">🚓 Police Misconduct</h1>
      <p className="purpose-text">The purpose of this site is to highlight the violence against protestors advocating for equality and against unjust killings happening across the nation currently. All of data, tweets, videos highlighted on this page comes from <a href="https://docs.google.com/spreadsheets/d/1YmZeSxpz52qT-10tkCjWOwOGkQqle7Wd1P7ZM1wMW0E/htmlview?usp=sharing&pru=AAABcqDrlKg*4DAtnEZYcPUvAY5KiZRXMw#">this google sheet</a>. All of these videos and tweets were curated by @greg_doucette and @jasonemiller on Twitter. Reach out to @mark_bruckert if you notice any problems with this site.</p>
      <select id="state-select" className="state-select" onChange={stateChange}>
        <option value="">All States</option>
      </select>
      {selectedState == "" &&
      <div>
      {ViolenceData.map((incident) =>
        <div className="incident-box">
          <h6 className="incident-location">{incident.field2}, {incident.state}</h6>
          <h1>{incident.field7}</h1>
          {incident.field6 !== "" &&
          <div>
            <iframe className="iframe" width="560" height="315" loading="lazy" src={"https://www.youtube.com/embed/" + incident.field6.replace("https://youtu.be/", "")} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> <br />
          </div>
          }
          <button className="tweet-button" onClick={() => window.open(incident.field4)}>View Tweet</button>
        </div>
      )}
      </div>
      }

      {selectedState !== "" &&
            <div>
            {ViolenceData.filter(incident => incident.state == selectedState).map((incident) =>
              <div className="incident-box">
                <h6 className="incident-location">{incident.field2}, {incident.state}</h6>
                <h1>{incident.field7}</h1>
                {incident.field6 !== "" &&
                <div>
                  <iframe className="iframe" width="560" height="315" loading="lazy" src={"https://www.youtube.com/embed/" + incident.field6.replace("https://youtu.be/", "")} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> <br />
                </div>
                }
                <button className="tweet-button" onClick={() => window.open(incident.field4)}>View Tweet</button>
              </div>
            )}
            </div>
      }
    </div>
  );
}

export default App;
